import manageNews from "../manageNews/locales/en.json";
import manageProducts from "../manageProducts/locales/en.json";
import managePartners from "../managePartners/locales/en.json";
import manageReferences from "../manageReferences/locales/en.json";
import manageServices from "../manageServices/locales/en.json";

const dashboardEN = {
  manageNews,
  manageProducts,
  managePartners,
  manageReferences,
  manageServices,
};

export default dashboardEN;
